<template>
  <v-dialog v-model="open" persistent max-width="400px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn block color="primary" dark v-bind="attrs" v-on="on">
        Phones
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Phones</span>
      </v-card-title>
      <v-card-text>
        <v-select
          :items="states"
          @change="selectState"
          item-text="title"
          item-value="id"
          label="State"
        ></v-select>

        <div v-if="phoneForm">
          <v-textarea
            name="input-7-1"
            label="Phone area codes"
            v-model="phone.codes"
            value=""
            hint="Hint text"
          />
          <v-text-field
            validate-on-blur
            counter="13"
            v-mask="'(###)###-####'"
            v-model="phone.phone"
            label="Phone"
            required
          />
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="() => (open = false)">
          Close
        </v-btn>
        <v-btn color="blue darken-1" @click="updatePhone" text> Save </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "PhonesForm",
  data() {
    return {
      open: false,
      phoneForm: false,
      state_id: null,
      phone: [],
    };
  },
  methods: {
    ...mapActions({
      loadStates: "states/loadStates",
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
    }),
    selectState(e) {
      this.phoneForm = true;
      this.$axios
        .get("/phone/get/" + e)
        .then((res) => {
          this.state_id = e;
          this.phone = res.data.phone;
        })
        .catch((err) =>
          console.log("file: PhonesForm.vue ~ line 67 ~ selectState", err)
        );
    },
    updatePhone() {
      this.$axios
        .post("/phone/update", {
          id: this.state_id,
          updated: {
            codes: this.phone.codes,
            phone: this.phone.phone,
          },
        })
        .then((res) => {
          this.showHandlerSnackbar({
            color: res.data.status,
            text: res.data.message,
            show: true,
          });
        })
        .catch((err) =>
          console.log("file: PhonesForm.vue ~ line 67 ~ selectState", err)
        );
    },
  },
  mounted() {
    this.loadStates();
  },
  computed: {
    ...mapGetters({
      states: "states/states",
    }),
  },
};
</script>

<style>
</style>